import React from 'react';
import PropTypes from 'prop-types';
import { compose, withHandlers, withState } from 'recompose';
import classNames from 'classnames';
import { getBoundingClientRect } from 'utils/dom/dom';

import { Link } from 'components/core/Link';
import { Section, Group } from 'components/core/Page';
import { H2 } from 'components/core/Typography';
import { SFIcon } from 'components/core/SFIcon';
import { Button } from 'components/core/Button';
import { Image } from 'components/core/Image';
import closeIcon from 'assets/images/icons/close-ex.svg';
import openIcon from 'assets/images/icons/plus.svg';

import './PSPJumpNav.scss';

export const enhance = compose(
	withState('jumpMenu', 'setJumpMenuState', false),
	withState('sticky', 'setStickyState', false),
	withHandlers({
		handleScroll:
			({ setJumpMenuState }) =>
			(id) => {
				setJumpMenuState(false);
				const el = document.getElementById(id);
				const sticky = document.querySelector('.sticky-search-bar');
				const top = window.scrollY + getBoundingClientRect(el).top;
				// sticky-search-bar is hidden when window.scrollY is < 80. Not sure where 80 is defined
				const stickySearchBarHeight = sticky.offsetHeight || 80;
				const safePadding = 16;
				window.scrollTo({
					top: top - (stickySearchBarHeight + safePadding),
					behavior: 'smooth',
				});
			},
	})
);

export const LinkList = ({ sections, handleScroll }) => (
	<Group className="jump-list">
		<ul>
			{sections.map((section) => {
				const sectionId = section.title
					.split(' ')
					.splice(0, 7)
					.join('-')
					.toLowerCase();

				return (
					<li
						onClick={() => handleScroll(sectionId)}
						onKeyDown={(event) => {
							if (event.key === 'Enter') {
								handleScroll(sectionId);
							}
						}}
						tabIndex={0}
						key={sectionId}
						className="content-list-item"
					>
						<div className="link-content-left">
							<div className="jump-link-content">
								<Link onClick={() => {}}>{section.title}</Link>
							</div>
						</div>
						<span className="link-content-right">
							<SFIcon
								className="link-content-icon"
								size="tiny"
								icon="chevron-right"
							/>
						</span>
					</li>
				);
			})}
		</ul>
	</Group>
);

export const Title = () => (
	<H2
		className="psp-jump-title"
		size="medium"
		weight="bold"
	>
		Jump to:
	</H2>
);

export const PSPJumpNav = ({
	sections,
	jumpMenu,
	setJumpMenuState,
	handleScroll,
}) => (
	<>
		{jumpMenu && (
			<Section className="sticky-jump-menu">
				<Title />
				<LinkList
					sections={sections}
					handleScroll={handleScroll}
				/>
			</Section>
		)}
		<Section className={classNames('standard-jump-menu')}>
			<Title />
			<LinkList
				sections={sections}
				handleScroll={handleScroll}
			/>
		</Section>
		<div className="jump-to-bar">
			<div className="jump-to-bar-left">
				<Button
					onClick={() => setJumpMenuState(!jumpMenu)}
				>
					<div className="jump-button-text">Jump to section...</div>
				</Button>
			</div>
			<div className="jump-to-bar-right">
				{jumpMenu ? (
					<Button
						onClick={() => setJumpMenuState(false)}
						className="jump-to-bar-right"
					>
						<Image
							src={closeIcon}
							alt="Close Icon"
							className="close-icon"
						/>
					</Button>
				) : (
					<Button
						onClick={() => setJumpMenuState(true)}
						className="jump-to-bar-right"
					>
						<Image
							src={openIcon}
							alt="Open Icon"
							className="open-icon"
						/>
					</Button>
				)}
			</div>
		</div>
	</>
);

LinkList.propTypes = {
	sections: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
	handleScroll: PropTypes.func,
};

PSPJumpNav.propTypes = {
	sections: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object]))
		.isRequired,
	setJumpMenuState: PropTypes.func,
	handleScroll: PropTypes.func,
	jumpMenu: PropTypes.bool,
};

export default enhance(PSPJumpNav);
